import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import { GameEngine } from './server/GameEngine';

class WinTextPool {
  private pool: WinText[] = [];

  constructor(initialPoolSize: number = 10) {
    for (let i = 0; i < initialPoolSize; i++) {
      this.pool.push(new WinText());
    }
  }

  public acquireWinText(): WinText {
    if (this.pool.length > 0) {
      return this.pool.pop()!;
    } else {
      return new WinText();
    }
  }

  public releaseWinText(winText: WinText) {
    winText.visible = false;
    winText.alpha = 1;
    winText.y = 0;
    this.pool.push(winText);
  }
}

export class WinText extends PIXI.Text {
  private static _pool: WinTextPool | null = null;

  public static get pool(): WinTextPool {
    if (!WinText._pool) {
      throw new Error('WinText pool is not initialized. Call WinText.createPool() first.');
    }
    return WinText._pool;
  }

  public static createPool(initialPoolSize: number = 10) {
    WinText._pool = new WinTextPool(initialPoolSize);
  }

  constructor() {
    super({
        text: "123456.00",
        style: {
            fontSize: 70,
            fontFamily: "TextFont",
            fill: "0xffffff",
            stroke: {
                color: "0x000000",
                width: 3,
              }
        }
      });
    this.anchor.set(0.5);
  }

  public async showWin(amount: number) {
    this.text = `+${GameEngine.getInstance().getFormatter().format(amount)}`;
    this.visible = true;
    this.alpha = 1;

    await gsap.to(this, { 
      y: this.y - 100, 
      alpha: 0, 
      duration: 1, 
      ease: 'power3.in', 
      onComplete: () => {
        WinText.pool.releaseWinText(this); 
      } 
    });
  }
}